export default "__VITE_ASSET__DGMIol9m__"